import { download } from '../helpers/exportFile'
import * as api from '../api'
import { getUrlCode } from '../utils/index.js'
export default {
  methods: {
    cacheExtensionParams (data) {
      var docType = 'article'
      if (data.doc_type == 'document') {
        docType = 'document'
      }
      window.postMessage({
        action: 'cacheArticleBaseInfo',
        data: {
          repoCache: {
            id_folder: data.id_folder,
            id_repo: data.id_repo,
            id: data.id,     //文章id,编辑器文章时用  
            docType,
            editor_type: data.doc_type
          }
        }
      }, '*')
    },
    operateCurrentArticles (data, type) {
      var editortype = ''
      var currentData = ''
      if ((this.$route.path === "/manuscriptrepo/myaudit" || this.$route.path === "/manuscriptrepo/mysendaudit" || this.$route.path === "/documentrepo/mysendaudit" || this.$route.path === "/documentrepo/myaudit") && !this.$store.state.repoList.showPreviewArticle) {
        currentData = data.content
      } else if ((this.$route.path === "/manuscriptrepo/myshare" || this.$route.path === "/manuscriptrepo/sharetome" || this.$route.path === "/documentrepo/myshare" || this.$route.path === "/documentrepo/sharetome") && !this.$store.state.repoList.showPreviewArticle) {
        currentData = data.article
      }
      else {
        currentData = data
      }

      if (currentData.doc_type === 'document') {
        editortype = 'documentrepo'
      } else {
        editortype = 'manuscriptrepo'
      }
      switch (type) {
        case "editor":
          console.log(this.$store.state.editor.isElectron)

          if (this.$store.state.editor.isElectron) {
            var editorUrl = ''
            if (currentData.doc_type == 'editor135') {
              this.cacheExtensionParams(currentData)
              editorUrl = 'http://www.135editor.com'
            }
            else if (currentData.doc_type == 'editor_xm') {
              this.cacheExtensionParams(currentData)
              editorUrl = 'https://xiumi.us/studio/v5#/paper/for/new/cube/0'
            } else if (currentData.doc_type === 'picture') {
              var currentRoutePicData = this.$router.resolve({
                path: '/atlasmanuscript',
                name: 'atlasmanuscript',
                query: { 'articleId': currentData.id, 'editortype': 'picture' },
                params: { 'articleId': currentData.id, 'editortype': 'picture' }
              })
              editorUrl = _POSTMESSAGEURL_ + currentRoutePicData.href
            } else if (currentData.doc_type === 'outer_chain') {
              var currentRoutePicData = this.$router.resolve({
                path: '/atlasmanuscript',
                name: 'atlasmanuscript',
                query: { 'articleId': currentData.id, 'editortype': 'outer_chain' },
                params: { 'articleId': currentData.id, 'editortype': 'outer_chain' }
              })
              editorUrl = _POSTMESSAGEURL_ + currentRoutePicData.href
            } else {
              var currentRouteData = this.$router.resolve({
                path: '/editorArticle',
                name: 'editorArticle',
                query: { 'articleId': currentData.id, 'editortype': editortype },
                params: { 'articleId': currentData.id, 'editortype': editortype }
              })
              editorUrl = _POSTMESSAGEURL_ + currentRouteData.href
            }
            window.parent.postMessage({
              action: 'isElectronOpen',
              data: {
                url: editorUrl
              }
            }, '*')
          } else {
            if (currentData.doc_type == 'editor135') {
              var isInstallPlug = sessionStorage.getItem('extensionIntalled')
              if (isInstallPlug == "true") {
                this.cacheExtensionParams(currentData)
                window.open('_blank').location.href = 'http://www.135editor.com'
              } else {
                this.$root.eventHub.$emit('browserplugModel', '')
              }
              // this.cacheExtensionParams(currentData)
              // window.open('_blank').location.href = 'http://www.135editor.com'
              return
            }
            if (currentData.doc_type == 'editor_xm') {
              var isInstallPlug = sessionStorage.getItem('extensionIntalled')
              if (isInstallPlug == "true") {
                this.cacheExtensionParams(currentData)
                window.open('_blank').location.href = 'https://xiumi.us/studio/v5#/paper/for/new/cube/0'
              } else {
                this.$root.eventHub.$emit('browserplugModel', '')
              }
              // this.cacheExtensionParams(currentData)
              // window.open('_blank').location.href = 'https://xiumi.us/studio/v5#/paper/for/new/cube/0'
              return
            }
            if (currentData.doc_type == 'outer_chain') {
              
              var flockOption = {
                ...this.$store.getters.baseOption,
                "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
                  "id": data.id,         // 必须字段： 稿件id
                }
              }
              var flockUrl = _API_ + 'api/lock/edit_lock'
              api._post(flockUrl, flockOption).then((res) => {
                if (res.code == 200) {
                  if (res.data) {
                    if (res.data.lock) {
                      let routeDataPic = this.$router.resolve({
                        path: '/atlasmanuscript',
                        name: 'atlasmanuscript',
                        query: { 'articleId': currentData.id, 'editortype': 'outer_chain' },
                        params: { 'articleId': currentData.id, 'editortype': 'outer_chain' }
                      })
                      //window.open('_blank').location.href = routeData.href
                      var newPicWindownName = 'newWindow' + currentData.id
                      let windowObjectReference = window.open(routeDataPic.href, newPicWindownName)
                    } else {
                      var userName = ''
                      if (res.data && res.data.user && res.data.user.username) {
                        userName = res.data.user.username
                      }
                      this.$notify.info({
                        title: '提示',
                        message: '已锁定编辑，编辑人：' + userName,
                        duration: 9000
                      })
                    }
                  }
                }
              }).catch((error) => {
                console.log(error)
              })
              return
            }
            if (currentData.doc_type == 'picture') {

              var flockOption = {
                ...this.$store.getters.baseOption,
                "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
                  "id": data.id,         // 必须字段： 稿件id
                }
              }
              var flockUrl = _API_ + 'api/lock/edit_lock'
              api._post(flockUrl, flockOption).then((res) => {
                if (res.code == 200) {
                  if (res.data) {
                    if (res.data.lock) {
                      let routeDataPic = this.$router.resolve({
                        path: '/atlasmanuscript',
                        name: 'atlasmanuscript',
                        query: { 'articleId': currentData.id, 'editortype': 'picture' },
                        params: { 'articleId': currentData.id, 'editortype': 'picture' }
                      })
                      //window.open('_blank').location.href = routeData.href
                      var newPicWindownName = 'newWindow' + currentData.id
                      let windowObjectReference = window.open(routeDataPic.href, newPicWindownName)
                    } else {
                      var userName = ''
                      if (res.data && res.data.user && res.data.user.username) {
                        userName = res.data.user.username
                      }
                      this.$notify.info({
                        title: '提示',
                        message: '已锁定编辑，编辑人：' + userName,
                        duration: 9000
                      })
                    }
                  }
                }
              }).catch((error) => {
                console.log(error)
              })
              return
            } else {
              var flockOption = {
                ...this.$store.getters.baseOption,
                "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
                  "id": data.id,         // 必须字段： 稿件id
                }
              }
              var flockUrl = _API_ + 'api/lock/edit_lock'
              api._post(flockUrl, flockOption).then((res) => {
                if (res.code == 200) {
                  if (res.data) {
                    if (res.data.lock) {
                      let routeData = this.$router.resolve({
                        path: '/editorArticle',
                        name: 'editorArticle',
                        query: { 'articleId': currentData.id, 'editortype': editortype },
                        params: { 'articleId': currentData.id, 'editortype': editortype }
                      })
                      var newWindownName = 'newWindow' + currentData.id
                      let windowObjectReference = window.open(routeData.href, newWindownName);
                    } else {
                      var userName = ''
                      if (res.data && res.data.user && res.data.user.username) {
                        userName = res.data.user.username
                      }
                      this.$notify.info({
                        title: '提示',
                        message: '已锁定编辑，编辑人：' + userName,
                        duration: 9000
                      })
                    }
                  }
                }
              }).catch((error) => {
                console.log(error)
              })

            }
          }
          break;
        case 'print':
          this.printChoiceModel(currentData)
          break;
        case 'exportWord':
          this.exportPortArticle(currentData)
          break;
        case 'exportPDF':
          var url = _API_ + 'api/article/utils/export_pdf' + '?company_id=' + this.$store.state.userinfo.company_id + '&id_article=' + currentData.id + '&token=' + this.$store.state.userinfo.token
          download(url, currentData)
          break;
        case 'sendAudit':
          if (currentData.ctrl && currentData.ctrl.role_type === 'flow') {
            this.sendAuditFlowarticle(currentData)
          } else {
            this.$root.eventHub.$emit('sendAuditModel', [currentData], 'oneSendAudit')
          }
          break;
        case 'share':
          this.$root.eventHub.$emit('shareToOtherModel', [currentData])
          break;
        case 'useArticle':
          this.useOrCancleUseArticle(currentData, type)
          break;
        case 'cancleuseArticle':
          this.useOrCancleUseArticle(currentData, type)
          break;
        case 'previewApp':
          this.$root.eventHub.$emit('previewAppModel', currentData)
          break;
        case 'move':
          this.$root.eventHub.$emit('setMoveArticleModel', [currentData], 'oneArticleMove')
          break;
        case 'saveAs':
          this.$root.eventHub.$emit('setMoveArticleModel', [currentData], 'saveAsOther')
          break;
        case 'saveAsV2':
          this.$root.eventHub.$emit('setMoveArticleModel', [currentData], 'saveAsOtherV2')
          break;
        case 'deleteArticle':
          this.deleteCurrentArticle(currentData)
          break;
        case 'collect':
          this.collectOrCancleCollect(currentData, type, editortype)
          break;
        case 'cancleCollect':
          this.collectOrCancleCollect(currentData, type, editortype)
          break;
        case 'fastAudit':
          this.$root.eventHub.$emit('auditArticleModel', currentData, 'fastAudit')
          break;
        case 'undoSendAudit':
          this.undoSendAudits(data)
          break;
        case 'push':
          this.checkWhiteList(currentData)
          break;
        case 'cancelpush':
          this.$root.eventHub.$emit('setPushService', currentData, 'typeIsCanclePush')
          break;
        case 'submitArticle':
          this.$root.eventHub.$emit('setSubmitArticleModel', [currentData])
          break;
        case 'cancleAuditCurrentArticle':
          this.cancleAuditCurrentArticle(currentData)
          break
        case 'deprecate':
          this.deprecateArticle(currentData, type)
          break;
        case 'cancledeprecate':
          this.deprecateArticle(currentData, type)
          break;
      }
    },

    //白名单检测
    checkWhiteList (currentData) {
      var urls = _API_ + 'api/article/utils/push_src_check'
      var options = {
        ...this.$store.getters.baseOption,
        "params": {
          "source": currentData.source,
        }
      }
      api._post(urls, options).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.$confirm('该稿件的来源为' + '【' + currentData.source + '】' + ',' + '请确认来源是否允许使用该稿件，以避免侵权。', '推送提示', {
              confirmButtonText: '继续推送',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.checkVideoSign(currentData)
            }).catch(() => {
              console.log('取消')
            });
          } else {
            this.checkVideoSign(currentData)
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    //检测是否有未推送的视频
    checkVideoSign (currentData) {
      var urls = _API_ + 'api/article/utils/get_unsigned_video'
      var options = {
        ...this.$store.getters.baseOption,
        "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
          "id_article": currentData.id,         // 必须字段： 稿件id
        }
      }
      api._post(urls, options).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            if (res.data.unsigned) {
              this.$confirm('检测到文章有未签发的视频，推送后会自动签发，是否继续？', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$root.eventHub.$emit('setPushService', currentData, 'typeIsPush')
              }).catch(() => {
                console.log('取消')
              });
            } else {
              this.$root.eventHub.$emit('setPushService', currentData, 'typeIsPush')
            }
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    getOperateLogs (id) {
      //获取操作日志
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 文章参数
          "id_article": id,           // 必须字段： 文章 ID
        }
      }
      this.$store.dispatch('GET_OPERATELOG_DATA', option)
    },

    printChoiceModel (currentData) {
      if (currentData.doc_type === 'document') {
        this.$root.eventHub.$emit('printArticleModel', currentData, false, 'printArticle')
      } else {
        this.$confirm('打印时是否带有文章基础信息？', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.$root.eventHub.$emit('printArticleModel', currentData, true, 'printArticle');
        }).catch((action) => {
          if (action === 'cancel') {
            this.$root.eventHub.$emit('printArticleModel', currentData, false, 'printArticle');
          }
        })
      }
    },
    exportPortArticle (currentData) {
      if (currentData.doc_type === 'document') {
        var url = _API_ + 'api/article/utils/export_ms_word' + '?company_id=' + this.$store.state.userinfo.company_id + '&id_article=' + currentData.id + '&token=' + this.$store.state.userinfo.token + '&needBasicInfo=' + 'false'
        download(url, currentData)
      } else {
        this.$confirm('导出时是否带有文章基础信息？', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          var url = _API_ + 'api/article/utils/export_ms_word' + '?company_id=' + this.$store.state.userinfo.company_id + '&id_article=' + currentData.id + '&token=' + this.$store.state.userinfo.token + '&needBasicInfo=' + 'true'
          download(url, currentData)
        }).catch((action) => {
          if (action === 'cancel') {
            var url = _API_ + 'api/article/utils/export_ms_word' + '?company_id=' + this.$store.state.userinfo.company_id + '&id_article=' + currentData.id + '&token=' + this.$store.state.userinfo.token + '&needBasicInfo=' + 'false'
            download(url, currentData)
          }
        })
      }
    },

    useOrCancleUseArticle (data, type) {
      var url = _API_ + 'api/article/utils/article_use_setter'
      var use_req = ''
      var successMessage = ''
      var useInfoMessage = ''
      var useAfterStatus = true
      if (type === 'useArticle') {
        use_req = true
        successMessage = '采用成功'
        useInfoMessage = '确认采用'
        useAfterStatus = true
      } else {
        use_req = false
        successMessage = '取消采用成功'
        useInfoMessage = '确认取消采用'
        useAfterStatus = false
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
          "id_article": data.id,         // 必须字段： 稿件id
          "flag_use": use_req                     //是否采用
        }
      }

      this.$confirm(useInfoMessage + '稿件' + '《' + data.title + '》' + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: successMessage
            });
            if (this.$route.path === "/manuscriptrepo/lasteditor") {
              this.$root.eventHub.$emit('setLastEditorArticleFlag', data, useAfterStatus, 'use')
            }
            if (this.$route.path === "/manuscriptrepo/myshare") {
              this.$root.eventHub.$emit('setMyShareArticleFlag', data, useAfterStatus, 'use')
            }
            if (this.$route.path === "/manuscriptrepo/sharetome") {
              this.$root.eventHub.$emit('setShareTomeArticleFlag', data, useAfterStatus, 'use')
            }

            if (this.$route.path === "/manuscriptrepo/myaudit") {
              this.$root.eventHub.$emit('deleteMyauditModel', '')
            }
            if (this.$route.path === "/manuscriptrepo/mysendaudit") {
              this.$root.eventHub.$emit('deleteCurrentSendAudit', '')
            }
            if (this.$route.path === "/manuscriptrepo/repomanuscript") {
              this.$root.eventHub.$emit('setFlagUseStatus', data, useAfterStatus)
            }
            this.$set(data, 'flag_use', useAfterStatus)
            this.getOperateLogs(data.id)
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });

    },


    deprecateArticle (data,type) {
      var url = _API_ + 'api/article/utils/article_deprecate_setter'
      var use_req = ''
      var successMessage = ''
      var useInfoMessage = ''
      var useAfterStatus = true
      if (type === 'deprecate') {
        use_req = true
        successMessage = '作废成功'
        useInfoMessage = '确认作废'
        useAfterStatus = true
      } else {
        use_req = false
        successMessage = '取消作废成功'
        useInfoMessage = '确认取消作废'
        useAfterStatus = false
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {     // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
          "id_article": data.id,         // 必须字段： 稿件id
          "flag_deprecate": use_req                     //是否采用
        }
      }

      this.$confirm(useInfoMessage + '稿件' + '《' + data.title + '》' + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: successMessage
            });
            if (this.$route.path === "/manuscriptrepo/lasteditor") {
              this.$root.eventHub.$emit('setLastEditorArticleFlag', data, useAfterStatus, 'deprecate')
            }
            if (this.$route.path === "/manuscriptrepo/myshare") {
              this.$root.eventHub.$emit('setMyShareArticleFlag', data, useAfterStatus, 'deprecate')
            }
            if (this.$route.path === "/manuscriptrepo/sharetome") {
              this.$root.eventHub.$emit('setShareTomeArticleFlag', data, useAfterStatus, 'deprecate')
            }

            if (this.$route.path === "/manuscriptrepo/myaudit") {
              this.$root.eventHub.$emit('deleteMyauditModel', '')
            }
            if (this.$route.path === "/manuscriptrepo/mysendaudit") {
              this.$root.eventHub.$emit('deleteCurrentSendAudit', '')
            }
            if (this.$route.path === "/manuscriptrepo/repomanuscript") {
              this.$root.eventHub.$emit('setFlagDeprecateStatus', data, useAfterStatus)
            }
            this.$set(data, 'flag_deprecate', useAfterStatus)
            this.getOperateLogs(data.id)
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });

    },

    deleteCurrentArticle (data) {
      var url = _API_ + 'api/article/editor/delete_article'
      var option = {
        ...this.$store.getters.baseOption,
        "params": {          // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
          "list_id": [data.id]    // 必须参数： 文章ID列表
        }
      }
      this.$confirm('确认删除稿件' + '《' + data.title + '》' + '？' + '<div style="color:#fd4a4a;margin-top:2px;">删除的稿件会在回收站中保存30天</div>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '删除成功'
            });
            this.$root.eventHub.$emit('deleteMoveArticle', data)
            if (this.$route.path === "/manuscriptrepo/lasteditor" || this.$route.path === "/documentrepo/lasteditor") {
              this.$root.eventHub.$emit('setLastEditorArticleFlag', data, '', 'delete')
            }
            if (this.$route.path === "/manuscriptrepo/myshare" || this.$route.path === "/documentrepo/myshare") {
              this.$root.eventHub.$emit('setMyShareArticleFlag', data, '', 'delete')
            }
            if (this.$route.path === "/manuscriptrepo/sharetome" || this.$route.path === "/documentrepo/sharetome") {
              this.$root.eventHub.$emit('setShareTomeArticleFlag', data, '', 'delete')
            }
            if (this.$route.path === "/manuscriptrepo/mycollection" || this.$route.path === "/documentrepo/mycollection") {
              this.$root.eventHub.$emit('deleteCollectMsp', data)
            }
            if (this.$route.path === "/manuscriptrepo/myaudit" || this.$route.path === "/documentrepo/myaudit") {
              this.$root.eventHub.$emit('deleteMyauditModel', data)
            }
            if (this.$route.path === "/manuscriptrepo/mysendaudit" || this.$route.path === "/documentrepo/mysendaudit") {
              this.$root.eventHub.$emit('deleteCurrentSendAudit', data)
            }
            setTimeout(() => {
              window.parent.postMessage('closeSortForm', '*');
            }, 2000)
            this.$set(data, 'id', '')
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });


    },

    collectOrCancleCollect (data, type, editortype) {
      var url = ''
      var successMessage = ''
      var errorMessage = ''
      var confirmMessage = ''
      var collectAfterStatus = true
      if (type === 'collect') {
        if (editortype === 'manuscriptrepo') {
          url = _API_ + 'api/article/collect/addCollect'
        }
        else if (editortype === 'documentrepo') {
          url = _API_ + 'api/article/doc/collect/addCollect'
        }
        successMessage = '收藏成功'
        errorMessage = '收藏失败'
        confirmMessage = '确认收藏'
        collectAfterStatus = true
      } else {
        if (editortype === 'manuscriptrepo') {
          url = _API_ + 'api/article/collect/removeCollect'
        }
        else if (editortype === 'documentrepo') {
          url = _API_ + 'api/article/doc/collect/removeCollect'
        }
        successMessage = '取消收藏成功'
        errorMessage = '取消收藏失败'
        confirmMessage = '确认取消收藏'
        collectAfterStatus = false
      }
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          "article_id": data.id //稿件id
        }
      }

      this.$confirm(confirmMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: successMessage
            })
            if (this.$route.path === "/manuscriptrepo/lasteditor" || this.$route.path === "/documentrepo/lasteditor") {
              this.$root.eventHub.$emit('setLastEditorArticleFlag', data, collectAfterStatus, 'collect')
            }
            if (this.$route.path === "/manuscriptrepo/mycollection" || this.$route.path === "/documentrepo/mycollection") {
              this.$root.eventHub.$emit('deleteCollectMsp', data)
            }

            if (this.$route.path === "/manuscriptrepo/myaudit" || this.$route.path === "/documentrepo/myaudit") {
              this.$root.eventHub.$emit('deleteMyauditModel', data)
            }
            if (this.$route.path === "/manuscriptrepo/mysendaudit" || this.$route.path === "/documentrepo/mysendaudit") {
              this.$root.eventHub.$emit('deleteCurrentSendAudit', data)
            }

            if (this.$route.path === "/manuscriptrepo/myshare" || this.$route.path === "/documentrepo/myshare") {
              this.$root.eventHub.$emit('setMyShareArticleFlag', '', '', 'delete')
            }
            if (this.$route.path === "/manuscriptrepo/sharetome" || this.$route.path === "/documentrepo/sharetome") {
              this.$root.eventHub.$emit('setShareTomeArticleFlag', '', '', 'delete')
            }

            this.$set(data.ctrl, 'is_collect', collectAfterStatus)


          } else {
            this.$notify.error({
              title: '失败',
              message: errorMessage
            })
          }
        }).catch((error) => {
          console.log(error)
          this.$notify.error({
            title: '失败',
            message: errorMessage
          })
        })

      }).catch(() => {
        console.log('取消')
      });

    },
    undoSendAudits (data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          "id": data.id,               // 必须字段：审核条目的 ID
          "audit_status": 'cancel',  // 必须字段：审核通过为  yes  审核不通过为  no   审核通过并指定下一个审核人为  doing 取消审核 cancel
          "id_to_user": '',  // 关联的可选（必须）字段：下一步审核人的 ID。当 audit_status 的值为 doing 时，此字段必须填。
          "comment": '',            // 可选字段：审核的评论内容
          "content_type": "article",
        }
      }
      var url = _API_ + 'api/article/audit/do_audit'
      this.$confirm('确认撤销送审', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.$root.eventHub.$emit('deleteCurrentSendAudit', data)
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });

    },
    cancleAuditCurrentArticle (data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          articleId: data.id,               // 必须字段：审核条目的 ID
        }
      }
      var url = _API_ + 'api/article/audit/role_flow_cancel_audit_req'
      this.$confirm('确认撤销审核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });
    },
    sendAuditFlowarticle (data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          articleId: data.id,               // 必须字段：审核条目的 ID
        }
      }
      var url = _API_ + 'api/article/audit/audit_flow_request'
      this.$confirm('确认送审', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });
    }
  }
}